export function checkClientEnv() {
  const ua = navigator.userAgent.toLowerCase();
  const isMobile = /mobile|android|iphone/i.test(ua);

  
  const isAndroidApp = /nongminribaoepaper/.test(ua);
  const isIOSApp = /nongmingrbforclientnongminribaoepaper/.test(ua);
  const isWeChat = /micromessenger/.test(ua);

  return {
    isApp: isAndroidApp || isIOSApp, // 客户端环境（包括安卓客户端和 iOS 客户端）
    isBrowser: !isAndroidApp && !isIOSApp && !isWeChat, // 不在客户端且不在微信浏览器的环境
    isAndroid: isAndroidApp || !!window.java, // 安卓设备
    isIOS: isIOSApp || !!window.webkit?.messageHandlers, // iOS 设备
    isMobileBrowser: isMobile && !(isAndroidApp || isIOSApp) && !isWeChat // 移动端浏览器环境
  };
}